import api from "../api";

export const getNotifications = async (page = 1, limit = 20) => {
  return api.getApi().get(api.getBaseUrl() + "notifications", { params: { page, limit } });
};

export const markNotificationAsRead = async (id) => {
  return api.getApi().put(api.getBaseUrl() + `notifications/${id}/read`);
};

export const markAllNotificationsAsRead = async () => {
  return api.getApi().put(api.getBaseUrl() + "notifications/read-all");
};

export const createNotification = async (data) => {
  return api.getApi().post(api.getBaseUrl() + "notifications", data);
};

export const bulkCreateNotifications = async (userIds, title, message, type, actionUrl) => {
  // This endpoint might need to be implemented on backend if it doesn't exist
  // For now, we can iterate or use a specific bulk endpoint if available
  // Assuming a bulk endpoint exists or we modify the create endpoint to handle arrays
  return api.getApi().post(api.getBaseUrl() + "notifications/bulk", { userIds, title, message, type, actionUrl });
};

export const deleteNotification = async (id) => {
  return api.getApi().delete(api.getBaseUrl() + `notifications/${id}`);
};
